import { Component } from 'react';
import AddTags from './modal/AddTags';
import ChangeFrequency from './modal/ChangeFrequency';
import ConfirmationModal from '../../../components/Modals/ConfirmationModal';
import { bulkActivatePrompts, bulkDisablePrompts } from './query';
import { showMessage } from '../../../helpers/showMessage';
import ReactSelect from '../../../components/ReactSelect';
import EditProject from './modal/editProject';

class AdditionalBox extends Component {
    constructor() {
        super();

        this.onOpenTagModal = this.onOpenTagModal.bind(this);
        this.onCloseTagModal = this.onCloseTagModal.bind(this);
        this.onOpenFrequencyModal = this.onOpenFrequencyModal.bind(this);
        this.onCloseFrequencyModal = this.onCloseFrequencyModal.bind(this);
        this.onCloseConfirmationModal = this.onCloseConfirmationModal.bind(this);
        this.onActivateSelected = this.onActivateSelected.bind(this);
        this.onDisableSelected = this.onDisableSelected.bind(this);
        this.onOpenActivateConfirmationModal = this.onOpenActivateConfirmationModal.bind(this);
        this.onOpenDisableConfirmationModal = this.onOpenDisableConfirmationModal.bind(this);

        this.state = {
            isAddTagsModalOpen: false,
            isFrequencyModalOpen: false,
            isOpenConfirmationModal: false,
            confirmFn: () => {},
            confirmationMessage: '',
            loading: false,
        };
    }

    onOpenTagModal() {
        this.setState({ isAddTagsModalOpen: true });
    }

    onCloseTagModal() {
        this.setState({ isAddTagsModalOpen: false });
    }

    onOpenFrequencyModal() {
        this.setState({ isFrequencyModalOpen: true });
    }

    onCloseFrequencyModal() {
        this.setState({ isFrequencyModalOpen: false });
    }

    onCloseConfirmationModal() {
        this.setState({
            isOpenConfirmationModal: false,
            confirmFn: () => {},
            confirmationMessage: '',
        });
    }

    onOpenActivateConfirmationModal() {
        this.setState({
            confirmFn: this.onActivateSelected,
            isOpenConfirmationModal: true,
            confirmationMessage: this.props.t('ai_tracking.global.activate_message'),
        });
    }
    onOpenDisableConfirmationModal() {
        this.setState({
            confirmFn: this.onDisableSelected,
            isOpenConfirmationModal: true,
            confirmationMessage: this.props.t('ai_tracking.global.disable_message'),
        });
    }

    async onDisableSelected() {
        try {
            this.setState({ loading: true });
            const body = {
                ids: this.props.selectedItems,
            };
            const res = await bulkDisablePrompts(body);
            const data = await res.json();
            if (!res.ok) {
                this.setState({ loading: false });
                return showMessage(data?.detail ?? this.props.t('global.something_went_wrong'));
            }
            this.props.onRemoveAllSelected();
            this.props.getPrompts();
            this.onCloseConfirmationModal();
        } catch (err) {
            console.log(err);
        } finally {
            this.setState({ loading: false });
        }
    }

    async onActivateSelected() {
        try {
            this.setState({ loading: true });
            const body = {
                ids: this.props.selectedItems,
            };
            const res = await bulkActivatePrompts(body);
            const data = await res.json();
            if (!res.ok) {
                this.setState({ loading: false });
                return showMessage(data?.detail ?? this.props.t('global.something_went_wrong'));
            }
            this.props.onRemoveAllSelected();
            this.props.getPrompts();
            this.onCloseConfirmationModal();
        } catch (err) {
            console.log(err);
        } finally {
            this.setState({ loading: false });
        }
    }

    render() {
        const { t } = this.props;

        const options = this.props.projects.map((x) => ({
            label: x.name,
            value: x.id,
        }));

        options.unshift({ label: 'All Projects', value: 'all' });

        const statusOptions = [
            { label: 'All', value: 'all' },
            { label: 'Active', value: 'active' },
            { label: 'Inactive', value: 'inactive' },
        ];
        return (
            <>
                <div className="table-additional-view justify-content-bewtween">
                    <div className="d-flex gap-10">
                        <ReactSelect
                            options={options}
                            value={options.find((x) => x.value === this.props.selectedProject)}
                            isSearchable={false}
                            placeholder="Select Project"
                            onChange={this.props.handleSelectProject}
                            blurInputOnSelect={true}
                            classname="mx-0"
                        />
                        <ReactSelect
                            options={statusOptions}
                            value={statusOptions.find((x) => x.value === this.props.selectedStatus)}
                            isSearchable={false}
                            placeholder="Select Status"
                            onChange={this.props.handleSelectStatus}
                            blurInputOnSelect={true}
                            classname="mr-10"
                        />
                    </div>
                    <div className="table-additional-view-btns ">
                        <EditProject
                            projects={this.props.projects}
                            getKeywords={this.props.getPrompts}
                            isBulk
                            selectedItems={this.props.selectedItems}
                        />
                        <button
                            className={'table-additional-view-btn '}
                            disabled={this.props.selectedItems.length === 0}
                            onClick={this.onOpenTagModal}
                        >
                            {t('ai_tracking.global.add_tags')}
                        </button>
                        <button
                            className={'table-additional-view-btn '}
                            disabled={this.props.selectedItems.length === 0}
                            onClick={this.onOpenFrequencyModal}
                        >
                            {t('ai_tracking.global.change_frequency')}
                        </button>
                        <button
                            disabled={this.props.selectedItems.length === 0}
                            className={'table-additional-view-btn'}
                            onClick={this.onOpenActivateConfirmationModal}
                        >
                            {t('ai_tracking.global.activate')}
                        </button>
                        <button
                            disabled={this.props.selectedItems.length === 0}
                            className={'table-additional-view-btn'}
                            onClick={this.onOpenDisableConfirmationModal}
                        >
                            {t('ai_tracking.global.deactivate')}
                        </button>
                    </div>
                </div>
                <AddTags
                    selectedItems={this.props.selectedItems}
                    isOpen={this.state.isAddTagsModalOpen}
                    onClose={this.onCloseTagModal}
                    getPrompts={this.props.getPrompts}
                    onRemoveAllSelected={this.props.onRemoveAllSelected}
                />
                <ChangeFrequency
                    selectedItems={this.props.selectedItems}
                    isOpen={this.state.isFrequencyModalOpen}
                    onClose={this.onCloseFrequencyModal}
                    getPrompts={this.props.getPrompts}
                    onRemoveAllSelected={this.props.onRemoveAllSelected}
                />
                <ConfirmationModal
                    isOpen={this.state.isOpenConfirmationModal}
                    message={this.state.confirmationMessage}
                    onClose={this.onCloseConfirmationModal}
                    onSubmit={this.state.confirmFn}
                    cancleBtn={t('ai_tracking.global.no')}
                    buttonName={t('ai_tracking.global.yes')}
                    loading={this.state.loading}
                />
            </>
        );
    }
}

export default AdditionalBox;
